import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-internal-memo2',
  templateUrl: './internal-memo2.component.html',
  styleUrls: ['./internal-memo2.component.scss']
})
export class InternalMemo2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
